module.exports = __webpack_public_path__ + "bfe7db8e32c26a2fc5625ef90d832843.pdf";